import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchBulkHistory,
    fetchBulkHistoryFail,
    fetchBulkHistorySuccess,
    fetchBulkMembersSuccess,
    fetchDataSuccess,
    fetchSingleRecordSuccess,
    resetState,
    updateRecord,
    updateRecordFailure,
    updateRecordSuccess
} from './bulk-tools.action';

import { BulkItem, BulkMember, BulkTools } from './bulk-tools.model';

export interface BulkToolsRecordsState {
    data: any;
    listData: BulkTools[];
    singleData: BulkTools;
    members: BulkMember[];
    bulkItems: BulkItem[];
    loading: boolean;
    error: any;
    total: number;
    submissionCompleted: boolean;
}

export const initialState: BulkToolsRecordsState = {
    data: null,
    listData: [],
    singleData: null,
    members: [],
    bulkItems: [],
    loading: false,
    error: null,
    total: 0,
    submissionCompleted: true
};


export const BulkToolsRecordReducer = createReducer(

    initialState,

    //Fetch Inital Data
    on(fetchDataSuccess, (state, { data }) => {
        return { ...state, data, error: null };
    }),

    //FETCH SINGLE
    on(fetchSingleRecordSuccess, (state, { singleData }) => {
        return { ...state, singleData, error: null };
    }),

    //FETCH BULK MEMBERS
    on(fetchBulkMembersSuccess, (state, { members, total }) => {
        return { ...state, members, total, error: null };
    }),

    //FETCH BULK HISTORY
    on(fetchBulkHistory, (state,) => {
        return { ...state, loading: true, error: null };
    }),

    on(fetchBulkHistorySuccess, (state, { bulkItems, total }) => {
        return { ...state, bulkItems, loading: false, total, error: null };
    }),

    on(fetchBulkHistoryFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    //ADD BULK RECORD
    on(updateRecord, (state, {}) => {
        return { ...state, submissionCompleted: false };
    }),
    on(updateRecordSuccess, (state, { }) => {
        return { ...state, submissionCompleted: true, error: null };
    }),
    on(updateRecordFailure, (state, { error }) => {
        return { ...state, submissionCompleted: false, error };
    }),

    //RESET STATE
    on(resetState, () => initialState)  // Reset action handler
    
);